import React, { useState, useEffect } from "react";
import { PiMoneyFill } from "react-icons/pi";
import useClickOutside from "../../../../customHooks/useClickOutside";
import FilterActionButton from "../../../FilterActionButton";
import classes from "./PopperMedicineTarget.module.css";
import { Row, Col } from "react-bootstrap";
import { Dropdown } from "../../../Dropdown";
import { Input } from "../../../Input";
const options = [
  { label: "All Value", value: { minTarget: 0, maxTarget: 0 } },
  { label: "Rs.0 to 10,000", value: { minTarget: 0, maxTarget: 10000 } },
  { label: "Rs 10,000 to 30,000", value: { minTarget: 10000, maxTarget: 30000 } },
  { label: "Rs 30,000 to 60,000", value: { minTarget: 30000, maxTarget: 60000 } },
  { label: "Rs 60,000 above", value: { minTarget: 60000, maxTarget: 0 } },
  { label: "Custom Target", value: "custom" },
];
const PopperMedicineTarget = ({
  lists = null,
  setter = () => { },
  children,
  maxValue,
  minValue,
  setMaxValue,
  setMinValue,
  listsClass = "",
  listStyle = null,
}) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [debounceMinValue, setDebounceMinValue] = useState(0);
  const [debounceMaxValue, setDebounceMaxValue] = useState(0);

  const [ref] = useClickOutside(() => {
    // setIsListOpen(false);
  });

  const setTargetsValueHandler = (val) => {
    setSelectedOption(val);
    if (val == "custom") {
      setDebounceMaxValue(0);
      setDebounceMinValue(0);
    }
    else {
      setDebounceMaxValue(val?.value?.maxTarget);
      setDebounceMinValue(val?.value?.minTarget);
    }
  }

  useEffect(() => {
    const effect = setTimeout(() => {
      setMaxValue(debounceMaxValue);
      setMinValue(debounceMinValue);
    }, 300);
    return () => clearTimeout(effect);
  }, [debounceMaxValue, debounceMinValue]);


  return (
    <div className={classes.wrapper} ref={ref}>
      <span>
        <FilterActionButton
          className={classes.iconHolder}
          onClick={() => {
            setIsListOpen((currentState) => !currentState);
          }}
        >
          <PiMoneyFill />
        </FilterActionButton>
      </span>

      <div
        style={{ ...listStyle }}
        className={[
          classes.actionsListWrapper,
          !isListOpen && classes.listClose,
          listsClass,
        ].join(" ")}
      >
        <Row>
          <Col sm={4}>
            <Dropdown options={options} placeholder={"All Target"} value={selectedOption} setter={(val) => setTargetsValueHandler(val)} />
          </Col>
          <Col sm={4}>
            <Input
              type="number"
              placeholder={"Min Value"}
              setter={setDebounceMinValue}
              value={debounceMinValue}
              parentCustomStyle={{ height: "100%" }}
              customStyle={{ height: "100%" }}
              disabled={selectedOption?.value !== "custom"}
            />
          </Col>
          <Col sm={4}>
            <Input
              type="number"
              placeholder={"Max Value"}
              setter={setDebounceMaxValue}
              value={debounceMaxValue}
              parentCustomStyle={{ height: "100%" }}
              customStyle={{ height: "100%" }}
              disabled={selectedOption?.value !== "custom"}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PopperMedicineTarget;
